import { useGenericRequestHandler } from '../../../handlers'

/**
 * @typedef {'affirmative' | 'assistive'} ToteEngagementMode
 */

/**
 * @type {Record<string, ToteEngagementMode>}
 */
export const ToteEngagementModeEnum = {
  AFFIRMATIVE: 'affirmative',
  ASSISTIVE: 'assistive'
}
/**
 * @typedef {Object} ToteStatus
 * @property {string} assignmentName
 * @property {string} className
 * @property {string} createdAt
 * @property {string} createdByAvatar
 * @property {string} createdByGreeting
 * @property {string} createdByName
 * @property {string} createdByUserId
 * @property {string} creatorText
 * @property {string} isFinalised
 * @property {ToteEngagementMode | null} lastLoopMode
 * @property {number} lastSeenEpoch
 * @property {string | null} lastTeply
 * @property {string} studentName
 * @property {string} theme
 * @property {string} toteId
 * @property {string} wasCreatedBySameUser
 */
export const useToteStatusQuery = ({
  toteId,
  refetchInterval,
  disabled = false,
  method = 'POST'
}) => {
  return useGenericRequestHandler({
    route: `v1/t/status/${toteId}`,
    enabled: Boolean(toteId) && !disabled,
    refetchInterval,
    method,
    options: { timeout: 25000 }
  })
}
